import { ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
   BillingIcon,
   DeliverIcon,
   EditIcon,
   MoveIcon,
   OrderIcon,
   ReportIcon,
   SendIcon,
} from 'assets';
import { TransferActionType } from 'interfaces';

export const useTransferActionTypeLabelsAndIcons = () => {
   const { t } = useTranslation();

   const TRANSFER_ACTION_TYPE_LABELS_AND_ICONS: Record<
      TransferActionType,
      { icon: ReactNode; label: string }
   > = useMemo(
      () => ({
         EDIT_BALANCE: { icon: <EditIcon />, label: t('transferActions.EDIT_BALANCE') },
         EDIT_ORDER_PALLETS: { icon: <EditIcon />, label: t('transferActions.EDIT_ORDER_PALLETS') },
         TRANSFER_PALLETS: { icon: <MoveIcon />, label: t('transferActions.TRANSFER_PALLETS') },
         TRANSFER_PALLETS_FOR_COLLECTION: {
            icon: <MoveIcon />,
            label: t('transferActions.TRANSFER_PALLETS_FOR_COLLECTION'),
         },
         SEND_PALLETS: { icon: <SendIcon />, label: t('transferActions.SEND_PALLETS') },
         DELIVER_PALLETS: { icon: <DeliverIcon />, label: t('transferActions.DELIVER_PALLETS') },
         ACCEPT_INTO_DESTINATION: {
            icon: <MoveIcon />,
            label: t('admission_modal.title'),
         },
         CANCEL_REPORT: {
            icon: <ReportIcon />,
            label: t('transferActions.CANCEL_REPORT'),
         },
         ACCEPT_ORDER: { icon: <OrderIcon />, label: t('transferActions.ACCEPT_ORDER') },
         ADD_ADDITIONAL_CHARGES: {
            icon: <BillingIcon />,
            label: t('transferActions.ADD_ADDITIONAL_CHARGES'),
         },
         REPORT_PALLETS: {
            icon: <ReportIcon />,
            label: t('transferActions.REPORT_PALLETS'),
         },
         CANCEL_ORDER: { icon: <OrderIcon />, label: t('transferActions.CANCEL_ORDER') },
         CREATE_ORDER: { icon: <OrderIcon />, label: t('transferActions.CREATE_ORDER') },
         SUBMIT_FOR_BILLING: {
            icon: <BillingIcon />,
            label: t('transferActions.SUBMIT_FOR_BILLING'),
         },
         UPDATE_ORDER: { icon: <OrderIcon />, label: t('transferActions.EDIT_ORDER_PALLETS') },
         ACCEPT_PALLETS_PICK_UP: {
            icon: <MoveIcon />,
            label: t('transferActions.ACCEPT_PALLETS_PICK_UP'),
         },
         REJECT_PALLETS_PICK_UP: {
            icon: <MoveIcon />,
            label: t('transferActions.REJECT_PALLETS_PICK_UP'),
         },
         REPORT_PALLETS_PICK_UP: {
            icon: <MoveIcon />,
            label: t('transferActions.REPORT_PALLETS_PICK_UP'),
         },
      }),
      [t],
   );

   return { TRANSFER_ACTION_TYPE_LABELS_AND_ICONS };
};
